import ContactCenter from '../../Apps/ContactCenter/Modules/ContactCenter'
import { updateCTRForAdobeAnswersAnalytics } from '../../helpers/ctr-updates';
import { enableRUByQueue, enableMockOfferId, enableGreetingMessageByQueue } from '../../utils/fg-utils';
import { splunkLog } from '../../Apps/ContactCenter/Api/api';
import store from '../../redux/store';

const phoneOrigins = ['outbound-phone', 'inbound-phone', 'bot-to-phone', 'chat-to-phone']

export const checkFeatureEligibility = (featureName:string, dispatch_case: string, currentContactId: string, queue: string, channel: string, origin: string) => (dispatch: any) => {
  try {
    splunkLog(`check featureName ${featureName} Eligibility for contact: ${currentContactId}, queue: ${queue}, channel: ${channel}, origin: ${origin}`);
    if (!currentContactId || !queue) {
      console.warn(`check featureName ${featureName} Eligibility: Missing required parameters`);
      return;
    }
    const featureFlags = store.getState()?.contactCenter?.featureFlagsOAC?.filter((feature: string) => feature.startsWith(featureName)) || [];
    const phoneOrigin = phoneOrigins.includes(origin);
    splunkLog(`check featureName ${featureName} Eligibility featureFlagsOAC: ${featureFlags}`);
    let isEligible = false;
    if (featureFlags.length > 0 && 
      (featureFlags.includes(`${featureName}Chats`) && channel === 'messaging') ||
      (featureFlags.includes(`${featureName}Voice`) && phoneOrigin)) {
      isEligible = true;
    }
    splunkLog(`check featureName ${featureName} Eligibility for contact: ${currentContactId} isEligible: ${isEligible}`);
    dispatch({ type: dispatch_case, payload: { eligible: isEligible, contactId: currentContactId } });
  } catch (error) {
    splunkLog(`Error checking featureName ${featureName} eligibility: ${error}`);
    dispatch({ type: dispatch_case, payload: { eligible: false, contactId: currentContactId } });
  }  
}
export const checkRUEligibility = (queue: string, agentLDAP: string) => async (dispatch: any) => {
  let fastFollowsRUWidget = false
  try {
    fastFollowsRUWidget = JSON.parse(localStorage.getItem('fastFollowFlags'))?.FAST_FOLLOWS_RECOMMENDED_UPGRADE === true
  } catch (e) {
    console.log('Error: Parsing localStorage for FAST_FOLLOWS_RECOMMENDED_UPGRADE', e)
    fastFollowsRUWidget = false
  }
  if (fastFollowsRUWidget) {
    try {
      fastFollowsRUWidget = await enableRUByQueue(queue, agentLDAP) 
      dispatch({ type: 'SET_RU_ELIGIBLE', payload: fastFollowsRUWidget })
    } catch (e) {
      console.log('Error fetching RU Eligiblity from Floodgate: ', e)
      dispatch({ type: 'SET_RU_ELIGIBLE', payload: false })
    }
    
  }
}

export const checkMockOfferIdEligibility = () => async (dispatch: any) => {
  const fastFollowsMockOfferId = await enableMockOfferId();
  dispatch({ type: 'SET_ENABLE_MOCK_OFFER_ID', payload: fastFollowsMockOfferId })
}

export const greetingMessageEligibility = 
  (queue: string = '', ldap: string = '', currentContactId: string = '') => 
  async (dispatch: any) => {
    try {
      splunkLog(`greetingMessageEligibility on FLoodGate for conversation with currentContactId: ${currentContactId}, queue: ${queue}`);

      if (!queue) {
        return;
      }
      const greetinMessageEligible = await enableGreetingMessageByQueue(queue, ldap);
      splunkLog(`dispatch greetingMessageEligibility for currentQueue: ${queue}: ${JSON.stringify(greetinMessageEligible)}`);     
      dispatch({ type: 'SET_QUEUE_GREETING_MESSAGE_ELIGIBILITY',  payload: {queueName: queue, eligibility: greetinMessageEligible} });
      return greetinMessageEligible
    } catch (e) {
      splunkLog(`greetingMessageEligibility chat: ${currentContactId}, queue: ${queue} Error fetching Greeting Message Eligibility from Floodgate: ${e}`);
      dispatch({ type: 'SET_QUEUE_GREETING_MESSAGE_ELIGIBILITY', payload: {queueName: queue, eligibility:false} });
      return false
    }
  };